<template>
  <div class="credit">
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="false"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :height="'200'"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'accountType'">
              {{ accountsTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'partnerType'">
              {{ enterprisePropertyData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'hnYfKqOrderAmount'">
              <p class="color" v-on:click.prevent="clickHnYfKqOrderAmount(scope)">{{
                scope.row[item.field]
              }}</p>
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/statistics.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
    },
    name: 'creditStatisticsList',
    props: ['params'],
    data() {
      let routeQuery = this.$route.query || null;
      return {
        load: false,
        img: './static/img/tips.png',
        query: {
          controlAreaCode: '', //事业部门
          partnerType: '', //合作伙伴类型
          onlyShowParent: '', //只显示母公司额度
          partnerCode: routeQuery && routeQuery.partnerCode ? routeQuery.partnerCode : '', //业务合作伙伴
          creditCode: '', //信用账户号
          accountTypes: routeQuery && routeQuery.accountTypes ? routeQuery.accountTypes : '', //账款类型
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        businessDepartmentList: [], //事业部门下拉列表
        enterprisePropertyList: [], //合作伙伴类型下拉列表
        requestStatusList: [], //申请状态下拉列表
        creditTypeList: [], //授信类型下拉列表
        accountsTypeList: [], //账款类型下拉列表
        onlyShowParentList: [
          { label: this.$t('applicationCredit.msg.no'), value: '0' },
          { label: this.$t('applicationCredit.msg.yes'), value: '1' },
        ],
        accountsTypeData: [],
        creditTypeData: [],
        enterprisePropertyData: [],
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'controlAreaName',
            title: 'creditStatistics.table.businessDepartmentName',
            sortable: true,
          },
          { field: 'partnerType', title: 'creditStatistics.table.partnerType' },
          { field: 'partnerCode', title: 'creditStatistics.table.partnerCode' },
          { field: 'partnerName', title: 'creditStatistics.table.partnerName' },
          { field: 'creditCode', title: 'creditStatistics.table.creditCode' },
          { field: 'creditCodeDesc', title: 'creditStatistics.table.creditCodeDesc' },
          { field: 'accountType', title: 'creditStatistics.table.accountType' },
          { field: 'referenceContractNo', title: 'creditStatistics.table.referenceContractNo' },
          { field: 'validDate', title: 'creditStatistics.table.validDate' },
          { field: 'invalidDate', title: 'creditStatistics.table.invalidDate' },
          { field: 'requestAmount', title: 'creditStatistics.table.availableAmount' },
          { field: 'availableAmount', title: 'creditStatistics.table.requestAmount' },
          { field: 'usedAmount', title: 'creditStatistics.table.usedAmount' },
          { field: 'hnYfKqOrderAmount', title: 'creditStatistics.table.hnYfKqOrderAmount' },
          { field: 'advanceCharge', title: 'creditStatistics.table.advanceCharge' },
          { field: 'supplierRefund', title: 'creditStatistics.table.supplierRefund' },
          { field: 'storageAmount', title: 'creditStatistics.table.storageAmount' },
          { field: 'deliveryAmount', title: 'creditStatistics.table.deliveryAmount' },
          { field: 'receivables', title: 'creditStatistics.table.receivables' },
          { field: 'salesRefund', title: 'creditStatistics.table.salesRefund' },
          { field: 'hnOrderAmount', title: 'creditStatistics.table.hnOrderAmount' },
          { field: 'createPersonName', title: 'creditStatistics.table.createPersonName' },
          { field: 'gmtCreate', title: 'creditStatistics.table.gmtCreate' },
          { field: 'mark', title: 'creditStatistics.table.mark' },
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      if (this.params) {
        this.getData();
        this.getDic();
        this.getButtonList();
      }
    },
    watch: {
      params() {
        if (this.params) {
          this.getData();
        }
      },
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.enterprisePropertyList = res.data.data;
              for (var item of res.data.data) {
                this.enterprisePropertyData[item['value']] = item['label'];
              }
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              for (var item of res.data.data) {
                this.creditTypeData[item['value']] = item['label'];
              }
            }
          });
        //账款类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'account_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.accountsTypeList = res.data.data;
              for (var item of res.data.data) {
                this.accountsTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      //获取数据
      getData() {
        this.load = true;
        let query = {};
        query.partnerCode = this.params.toString();
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.$axios.post(API.APPLICATION_STATISTICS_LIST_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //导出
        if (type === 'exportData') {
          this.export();
        }
      },
      //跳转查看占用的已签未付款订单详情
      clickHnYfKqOrderAmount(e) {
        let path = {
          path: '/credit/hnYfKqAmountOrderList',
          name: 'hnYfKqAmountOrderList',
          meta: {
            keepAlive: false,
          },
          query: { id: e.row.id },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let query = {};
        query.partnerCode = this.params.toString();
        const params = filterEmpty(query);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios.post(API.EXPORT_APPLICATION_STATISTICS_API, filterEmpty(params)).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //没有选择数据提示
      noSelectData() {
        this.$message({
          showClose: true,
          message: this.$t('xTable.noSelectData'),
          type: 'error',
        });
      },
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/credit/statisticsDetail',
          name: 'creditStatisticsDetail',
          meta: {
            keepAlive: false,
          },
          query: {
            partnerCode: value.row.partnerCode,
            partnerType: value.row.partnerType,
            id: value.row.id,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .credit .color {
    color: #0071fe;
    cursor: pointer;
  }
</style>
